import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { IMenuFlowPage } from '@shared/state';

@Component({
    selector: 'shared-wizzard-hints',
    templateUrl: './wizzard-hints.shared.component.html',
    styleUrls: ['./wizzard-hints.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizzardHintsComponent implements OnInit {
    public hasError$: Observable<boolean>;
    public wizzardPageTotalQuantity$: Observable<number>;
    public showAddUp$: Observable<boolean>;
    public showCounter$: Observable<boolean>;
    public showChooseMin$: Observable<boolean>;

    @Input() public page: IMenuFlowPage;
    @Input() public labelSelect: string = 'Select';
    @Input() public labelAdd: string = 'Add up to';

    constructor(
        public controllers: Controllers,
        public wizzardService: Services.WizzardService,
    ) { }

    ngOnInit(): void {
        this.wizzardPageTotalQuantity$ = this.controllers.wizzard.wizzardPageTotalQuantity$(this.page.PageIdentifier);

        this.showAddUp$ = this.controllers.wizzard.wizzardHintShowAddUpTo$(this.page);
        this.showCounter$ = this.controllers.wizzard.wizzardHintShowCounter$(this.page);
        this.showChooseMin$ = this.controllers.wizzard.wizzardHintShowChooseMinimumQuantity$(this.page);
    }
}
